'use client';

import { useSyncExternalStore } from 'react';
import { subscribePersistedVariantStorage } from '@/contexts/LocalStore';
import { useOptionalProduct } from '@/contexts/ProductContext';
import { getVariantBasedOnLastSelectedOptions } from '@/utils/product/getLastSelectedVariant';
import {
  applyOptionValuesToVariant,
  spreadOptionsObj,
} from '@/utils/product/product-context-helpers';

/**
 * Card pricing variant from PDP selection or persisted options (default Queen).
 * Re-subscribes via `useSyncExternalStore` when localStorage changes, server snapshot is `null`.
 */
export function useVariantAware(shopifyProduct) {
  const pdpOptions = useOptionalProduct()?.selectedVariant?.selectedOptions;

  return useSyncExternalStore(
    subscribePersistedVariantStorage,
    () => {
      if (!shopifyProduct?.variants?.length) return null;

      let variant = pdpOptions?.length
        ? applyOptionValuesToVariant(
            shopifyProduct,
            undefined,
            spreadOptionsObj(pdpOptions),
          ).selectedVariant
        : getVariantBasedOnLastSelectedOptions(shopifyProduct);

      return variant ?? shopifyProduct.variants[0];
    },
    () => null,
  );
}
